function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "team",
  transform: "translate(0.102 -0.177)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "M15.5,27.31H2.126a2.108,2.108,0,0,1-1.6-.74,2.2,2.2,0,0,1-.508-1.714L1.845,10.844a4.613,4.613,0,0,1,4.079-4.01,4.37,4.37,0,0,1-.78-2.5,4.253,4.253,0,1,1,8.5,0,4.372,4.372,0,0,1-.766,2.478h5.237a4.366,4.366,0,0,1-.766-2.478,4.253,4.253,0,1,1,8.5,0,4.364,4.364,0,0,1-.781,2.5,4.611,4.611,0,0,1,4.079,4.01l1.827,14.012a2.193,2.193,0,0,1-.508,1.714,2.108,2.108,0,0,1-1.6.74Z",
  transform: "translate(0 0.277)",
  fill: "#622af2",
  stroke: "#622af2",
  strokeMiterlimit: 10,
  strokeWidth: 0.2
}));

function SvgUsers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.206,
    height: 27.51,
    viewBox: "0 0 31.206 27.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.5e0489f3.svg";
export { ForwardRef as ReactComponent };